import React from 'react';
import {
  Chart,
  ChartTooltip,
  ChartSeries,
  ChartLegend,
  ChartSeriesItem
} from '@progress/kendo-react-charts';

class ChartContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      categories: []
    };
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  // componentDidMount() {
  //   this.updateSeries()

  // }

  // componentWillUnmount() {
  //   this.setState({ series: [] })
  // }

  // componentDidUpdate(prevProps) {
  //   $("#chart").trigger("click");
  //   if (prevProps.date !== this.props.date) {
  //     this.updateSeries()
  //   }
  // }

  // updateSeries = () => {
  //   let series = [];
  //   if (this.props.data.length === 1) {
  //     series = [
  //       {  value: 1 - this.props.data[0].value },
  //       {  value: this.props.data[0].value }
  //     ]
  //   } else if (this.props.data.length > 1) {
  //     series = this.props.data;
  //   } else {
  //     series = [
  //       {  value: 1 }
  //     ]
  //   }
  //   this.setState({ series,categories });
  // }

  render() {
    return (
      <Chart>
        <ChartLegend position="bottom" />
        <ChartTooltip />
        <ChartSeries>
          <ChartSeriesItem data={this.props.data || ['100% - empty']} type="pie" />
        </ChartSeries>
      </Chart>
    );
  }
}
export default ChartContainer;
